// ** React Imports
import { Navigate, useSearchParams } from "react-router-dom";
import { useContext, Suspense } from "react";

// ** Context Imports
import { AbilityContext } from "@src/utility/context/Can";
import { subject } from "@casl/ability";
import { CurrentBuildingContext } from "../../../contexts/currentBuilding";

const PrivateRoute = ({ children, route }) => {
  // ** Hooks & Vars
  const ability = useContext(AbilityContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const appView = searchParams.get("view");

  const { currentBuilding } = useContext(CurrentBuildingContext);

  const user = JSON.parse(localStorage.getItem("userData"));

  if (route) {
    let action = null;
    let resource = null;
    let restrictedRoute = false;

    if (route?.meta) {
      action = route.meta.action;
      resource = route.meta.resource;
      restrictedRoute = route.meta.restricted;
    }
    if (!user) {
      return <Navigate to="/login" />;
    }
    if (user && restrictedRoute) {
      return <Navigate to="/" />;
    }

    if (user && restrictedRoute && user.role?.name === "client") {
      return <Navigate to="/access-control" />;
    }

    if (
      resource &&
      appView &&
      !(Array.isArray(action) ? action : [action || "read"]).some((item) =>
        ability.can(item, subject(resource, { view: appView })) ||
        ability.can(item, subject(resource, { view: "building" })) ||
        ability.can(item, subject(resource, { view: "company" })) ||
        ability.can(item, resource)
      )
    ) {
      return <Navigate to="/auth/not-authorized" replace />;
    }

    if (
      resource &&
      !appView &&
      !(Array.isArray(action) ? action : [action || "read"]).some((item) =>
        ability.can(
          item,
          subject(resource, { view: currentBuilding?._id || "company" })
        ) ||
        ability.can(item, subject(resource, { view: "building" })) ||
        ability.can(item, subject(resource, { view: "company" })) ||
        ability.can(item, resource)
      )
    ) {
      return <Navigate to="/auth/not-authorized" replace />;
    }
  }

  return <Suspense fallback={null}>{children}</Suspense>;
};

export default PrivateRoute;
